import React from 'react'
import styled from 'styled-components'
import { toPairs } from 'ramda'
import { useFormikContext } from 'formik'

import ENV_VARS from '@/config'
import { breakpoints } from '@/styles'
import {
  FormProps,
  LoginGroup,
  SocialButtonsProps
} from '@/features/Auth/login-modal/types'
import { SocialButton } from '@/components/button'

import { ReactComponent as AppleIcon } from './images/apple-icon.svg'
import { ReactComponent as FacebookIcon } from './images/facebook-icon.svg'
import { ReactComponent as GoogleIcon } from './images/google-icon.svg'

const { BACKEND_SERVER } = ENV_VARS

const socialLoginGroup: LoginGroup = {
  google: {
    name: 'Google',
    icon: GoogleIcon,
    url: `${BACKEND_SERVER}/social_login/google/sign_in`
  },
  fb: {
    name: 'Facebook',
    icon: FacebookIcon,
    url: `${BACKEND_SERVER}/social_login/facebook/sign_in`
  },
  apple: {
    name: 'Apple',
    icon: AppleIcon,
    url: `${BACKEND_SERVER}/social_login/apple/sign_in`
  }
}

const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  width: 100%;

  @media (max-width: ${breakpoints.phoneMax}) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`

const ButtonWrapper = styled.div``

const SocialButtons: React.FC<SocialButtonsProps> = ({
  onClick,
  trackingId = `web-signupsocial`
}) => {
  const { values } = useFormikContext<FormProps>()

  const accountText = values?.account_type ? `-${values?.account_type}` : ''
  return (
    <ButtonsWrapper>
      {toPairs(socialLoginGroup).map(([item, socialItem], index) => {
        const SocialIcon = socialItem.icon
        const name = socialItem.name
        return (
          <ButtonWrapper key={index}>
            <SocialButton
              id={`${trackingId}-${item}${accountText}`}
              onClick={(e: React.MouseEvent<HTMLElement>) =>
                onClick(item, socialItem, e)
              }
            >
              <SocialIcon width={20} height={20} />
              {name}
            </SocialButton>
          </ButtonWrapper>
        )
      })}
    </ButtonsWrapper>
  )
}

export default SocialButtons
